import { render, staticRenderFns } from "./DelegateDetailsPanel.vue?vue&type=template&id=74701ff8"
import script from "./DelegateDetailsPanel.vue?vue&type=script&lang=js"
export * from "./DelegateDetailsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports